import { IStore } from '../../index'

export function isSyncing(state: IStore) {
  return state.synchronize.isSynchronizing
}

export function getLastSyncSeconds(state: IStore) {
  return state.synchronize.lastDateSync || 0
}

export function getLastSyncDate(state: IStore) {
  return new Date(state.synchronize.lastDateSync)
}

export function isFirstTime(state: IStore) {
  return state.synchronize.syncCount === 0
}
